import { AccountFragment } from 'src/graphql'
import { useCallback, useQueryParams, useVertical } from '.'

const useRedirectUriBuilder = () => {
  const vertical = useVertical()
  const { redirect_uri: redirectUri, marketshow } = useQueryParams()

  return useCallback(
    (account: AccountFragment) => {
      if (vertical.id === 'promptingu' && account.promptinguLoginUrl) {
        return account.promptinguLoginUrl
      }

      if (!redirectUri) {
        return undefined
      }

      const url = new URL(decodeURIComponent(redirectUri))

      if (marketshow) {
        url.searchParams.append('marketshow', marketshow)
      }

      if (vertical.id === 'greenerstill') {
        url.searchParams.append(
          account.isAffiliate ? 'repDID' : 'customerDID',
          account.genealogyId.toString(),
        )
      }

      return url.toString()
    },
    [vertical.id, redirectUri, marketshow],
  )
}

export default useRedirectUriBuilder
